import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';

interface Agreement {
  tariff_code: string;
  product_display_name: string;
  valid_from: string | null;
  valid_to: string | null;
}

interface AgreementTableProps {
  agreements: Agreement[];
}

export default function AgreementTable({ agreements }: AgreementTableProps) {
  const theme = useTheme();
  
  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  const formatValidTo = (dateString: string | null) => {
    if (!dateString) return 'Ongoing';
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  if (agreements.length === 0) {
    return null;
  }

  return (
    <TableContainer 
      component={Paper} 
      sx={{ 
        mb: 2,
        backgroundColor: theme.palette.background.default
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Tariff Code</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Valid From</TableCell>
            <TableCell>Valid To</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {agreements.map((agreement, agreementIndex) => (
            <TableRow key={agreementIndex}>
              <TableCell>{agreement.tariff_code}</TableCell>
              <TableCell>{agreement.product_display_name}</TableCell>
              <TableCell>{formatDate(agreement.valid_from)}</TableCell>
              <TableCell>{formatValidTo(agreement.valid_to)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
